export enum CourseRouteNames {
  CourseList = "courseList",
  NewCoursePrerequisites = "newCoursePrerequisites",
  NewCourse = "newCourse",
  EditCourse = "editCourse",
  ExisitingCoursesUnderCurriculum = "exisitingCoursesUnderCurriculum",
}
